import React from "react";
import parse, { domToReact } from "html-react-parser";
import sanitizeHtml from 'sanitize-html'
import ImageViewer from './image_viewer';
import { Link } from "@reach/router";

const sanitizeConfig = {
  allowedTags: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'img', 'blockquote', 'p', 'a', 'ul', 'ol',
    'nl', 'li', 'b', 'i', 'strong', 'em', 'strike', 'abbr', 'code', 'hr', 'br', 'div',
    'table', 'thead', 'caption', 'tbody', 'tr', 'th', 'td', 'pre', 'nav'],
  allowedAttributes: {
    nav: ['class'],
    a: ['href', 'name', 'target'],
    h1: ['id'],
    h2: ['id'],
    h3: ['id'],
    h4: ['id'],
    h5: ['id'],
    h6: ['id'],
    img: ['src', 'alt']
  },
}

const HtmlParser = ({ html, fontSize }) => {
  const options = {
    replace: function ({ attribs, name, children }) {
      if (!attribs) return;

      if (name === "img") {
        return (
          <ImageViewer imgs={[{ src: attribs.src, caption: attribs.alt }]} />
        );
      }

      if (name === "a" && attribs.href.startsWith('/')) {
        return <Link to={attribs.href}>{domToReact(children, options)}</Link>
      }
    },
  }
  return (
    <div className='html_parser' style={{ fontSize: `${fontSize}%` }}>
      {parse(sanitizeHtml(html, sanitizeConfig) || '', options)}
    </div>
  );
};

export default HtmlParser;
